<template>
    <div>
      <aiKoutu     type="1"> </aiKoutu> 
    </div>
  </template>
  <script>
  import aiKoutu from '../tongyong/aiKoutu.vue'
   
  export default {
  
    components: {
      aiKoutu: aiKoutu 
    },
  
    data() {
      return {
        // 获取用户列表参数
        
      };
    },
    props: [],
   
    watch: {
   
    },
    created() {
   
    },
    mounted() {
   
    }
  }
  </script>
